import { makeStyles, Theme } from '@material-ui/core/styles'
import { HARMONY_TAB_HEIGHT } from './useHarmonyTabStyles'

/** Top/bottom padding of a Harmony expanded nav panel, in pixels. Mirrors theme.harmony.spacing.sm. */
const HARMONY_PANEL_PADDING_PX = 8

/** Height of a Harmony expanded nav panel: tab row + padding + border, in pixels. */
export const HARMONY_PANEL_HEIGHT =
    HARMONY_TAB_HEIGHT + HARMONY_PANEL_PADDING_PX * 2 + 1

/** Harmony light-header panel chrome. */
export const useHarmonyPanelStyles = makeStyles((theme: Theme) => ({
    panelLight: {
        // !important: this class is always combined via clsx with a classic-header background
        // class of equal specificity (StudioPage's studioNavContainer, ProjectPagePartialNavBarMenu's
        // actionBar) — JSS insertion order across the two makeStyles factories isn't guaranteed
        // to favor this one, so !important forces the override.
        background: `${theme.harmony.colors.headerBackground} !important`,
        boxShadow: theme.harmony.colors.panelShadow,
    },
}))
